/**
 * Logging configuration for EZAccounting
 * Controls the verbosity of console output
 */

export const LOGGING_CONFIG = {
  // Set to 'production' to reduce console output
  // Set to 'development' for more verbose logging
  environment: process.env.NODE_ENV || 'development',
  
  // Log levels: ERROR (0), WARN (1), INFO (2), DEBUG (3)
  levels: {
    production: 0,  // Only errors
    development: 2, // Info and above
    testing: 1      // Warnings and errors
  },
  
  // Component-specific logging control
  components: {
    voice: true,      // Voice assistant logging
    api: true,        // API call logging
    navigation: true, // Navigation logging
    translation: false, // Translation logging (usually verbose)
    i18n: false      // i18n initialization logging
  }
};

// Helper function to check if logging is enabled for a component
export const isLoggingEnabled = (component: keyof typeof LOGGING_CONFIG.components): boolean => {
  return LOGGING_CONFIG.components[component];
};

// Helper function to get current log level
export const getLogLevel = (): number => {
  const env = LOGGING_CONFIG.environment as keyof typeof LOGGING_CONFIG.levels;
  return LOGGING_CONFIG.levels[env] || LOGGING_CONFIG.levels.development;
};
